import React from 'react';
import classNames from 'classnames';

export const LinkButton = ({
  className,
  children,
  onClick,
  disabled = false,
  bold = false,
  showUnderlineOnHover = false,
  showUnderline = false,
  size = 'md',
  color = 'brand',
  hoverColor = 'highlighted',
  activeColor = 'faded-brand',
}) => (
  <button
    type="button"
    className={classNames(
      `cursor-pointer text-${size} text-${color} hover:text-${hoverColor} active:text-${activeColor}`,
      { 'font-bold': bold },
      { 'hover:underline': showUnderlineOnHover },
      { 'underline': showUnderline },
      className
    )}
    onClick={onClick}
    disabled={disabled}
  >
    { children }
  </button>
)

export default LinkButton;
